import { HBox } from '../../layout';
import React from 'react';

/**
 * Props for a {@link PatientDetailsHorizontalFlexElement} component.
 * @author agd
 */
type PatientDetailsHorizontalFlexElementProps = {
  label: string;
  value: string;
};

/**
 * Simple component for elements that are meant to be displayed in the form of
 * "Label: Value" with specific flex values.
 *
 * @param props a {@link PatientDetailsHorizontalFlexElementProps} object
 * @return the created {@link JSX.Element}.
 * @author agd
 * @constructor
 */
export function PatientDetailsHorizontalFlexElement({
  label,
  value
}: PatientDetailsHorizontalFlexElementProps): JSX.Element {
  return (
    <HBox className="ehs-patient-details-horizontal-flex-element">
      <span className="label">
        <b>{label}</b>:
      </span>
      <span className="value">{value}</span>
    </HBox>
  );
}
